import TYPES from './types';
import { getCities, getZipcode } from '../api';

export const searchCityOptions = ({ name }) => {
  return dispatch => {
    getCities({ name })
      .then(({ data }) => {
        dispatch({
          type: TYPES.getCityOptions,
          payload: data.map(result => {
            const {
              id,
              name,
              stateAbbrev,
              stateId,
            } = result;

            return {
              id,
              stateId,
              name,
              stateAbbrev,
            }
          }),
        })
      })
  }
};

export const searchZipcodeOptions = ({ zipcode }) => {
  return dispatch => {
    getZipcode({ zipcode })
      .then(({ data }) => {
        dispatch({
          type: TYPES.getZipcodeOptions,
          payload: data.data,
        })
      })
  }
}
